import { MenuItem } from './common';
import {
    ApartmentOutlined,
    AppstoreOutlined,
    BarcodeOutlined,
    CameraOutlined,
    ClockCircleOutlined,
    CompressOutlined,
    ContactsOutlined,
    CreditCardOutlined,
    DatabaseOutlined,
    EditOutlined,
    FileSearchOutlined,
    FileWordFilled,
    FireOutlined,
    GiftOutlined,
    HomeOutlined,
    NotificationOutlined,
    SearchOutlined,
    SettingOutlined,
    TeamOutlined,
    ToolOutlined,
    TransactionOutlined,
    UnorderedListOutlined,
    UserOutlined,
    WalletOutlined,
} from '@ant-design/icons';

export const SidebarItems: MenuItem[] = [
    {
        id: 1,
        isActive: false,
        title: 'پیشخوان',
        icon: <HomeOutlined />,
        link: '/dashboard/overview',
    },
    {
        id: 2,
        isActive: false,
        title: 'ووچر های یوتوپیا',
        icon: <BarcodeOutlined />,
        link: '/dashboard/utopia-vouchers',
    },
    {
        id: 3,
        isActive: false,
        title: 'استعلام ووچر',
        icon: <CompressOutlined />,
        link: '/dashboard/track-voucher',
    },
    {
        id: 25,
        isActive: false,
        title: 'شارژ یوتوپیا',
        icon: <CreditCardOutlined />,
        link: '/dashboard/deposit-utopia',
    },
    {
        id: 4,
        isActive: false,
        title: 'مدیریت کاربران',
        icon: <UserOutlined />,
        link: '/dashboard/users',
    },
    {
        id: 5,
        isActive: false,
        title: 'تغییر نرخ',
        icon: <ApartmentOutlined />,
        link: '/dashboard/fiats',
    },
    {
        id: 7,
        isActive: false,
        title: 'سوابق معامله',
        icon: <ClockCircleOutlined />,
        link: '',
        childrens: [
            {
                id: 701,
                title: 'سفارشات',
                link: '/dashboard/orders',
            },
            {
                id: 702,
                title: 'تراکنش‌ها',
                link: '/dashboard/transactions',
            },
            {
                id: 703,
                title: 'معاملات',
                link: '/dashboard/orders-transactions',
            },
        ],
    },
    {
        id: 20,
        isActive: false,
        title: 'هش های سوخته',
        link: '/dashboard/old-tx-ids',
        icon: <FireOutlined />,
    },
    {
        id: 27,
        isActive: false,
        title: 'تاریخچه کوکوین',
        icon: <TransactionOutlined />,
        link: '/dashboard/kucoin-history',
    },
    {
        id: 26,
        isActive: false,
        title: 'گزارش کمپین ها',
        link: '/dashboard/campaign-reports',
        icon: <GiftOutlined />,
    },
    {
        id: 28,
        isActive: false,
        title: 'پاپ‌آپ ها',
        icon: <NotificationOutlined />,
        link: '/dashboard/popups',
    },
    {
        id: 8,
        isActive: false,
        title: 'اقدامات',
        icon: <ToolOutlined />,
        link: '',
        itemKey: 'waitingForAcceptReceipt',
        childrens: [
            {
                id: 801,
                title: 'خرید',
                link: '/dashboard/orders-transactions/buys-waiting-for-admin',
                itemKey: 'buyWaitingForAcceptReceipt',
            },
            {
                id: 802,
                title: 'فروش',
                link: '/dashboard/orders-transactions/sells-waiting-for-admin',
                itemKey: 'sellWaitingForAcceptReceipt',
            },
            {
                id: 803,
                title: 'ترید',
                link: '/dashboard/orders-transactions/trades-waiting-for-admin',
                itemKey: 'tradeWaitingForAcceptReceipt',
            },
        ],
    },
    {
        id: 9,
        isActive: false,
        title: 'مدیریت محتوا',
        icon: <EditOutlined />,
        link: '',
        childrens: [
            {
                id: 1901,
                title: 'تاپیک ها',
                link: '/dashboard/content/topics',
            },
            {
                id: 1902,
                title: 'دسته بندی',
                link: '/dashboard/content/categories',
            },
            {
                id: 1903,
                title: 'محتوا',
                link: '/dashboard/content/contents',
            },
            {
                id: 1904,
                title: 'مدیریت ارز ها',
                link: '/dashboard/content/manage-markets',
            },
        ],
    },
    {
        id: 10,
        isActive: false,
        title: 'سود و زیان',
        icon: <DatabaseOutlined />,
        link: '',
        childrens: [
            {
                id: 1001,
                title: 'مدیریت تامین موجودی',
                link: '/dashboard/balancer-transactions',
            },
            {
                id: 1002,
                title: 'گزارشات سود و زیان',
                link: '/dashboard/balancer-transactions/loss-and-profit-report',
            },
        ],
    },
    // {
    //     id: 10,
    //     isActive: false,
    //     title: 'مشاهده واریز های آفلاین',
    //     icon: <ClockCircleOutlined />,
    //     link: '/dashboard/offline-deposit-orders',
    // },
    // {
    //     id: 10.5,
    //     isActive: false,
    //     title: 'مشاهده تراکنش های حساب',
    //     icon: <CreditCardOutlined />,
    //     link: '/dashboard/bank-account-statement',
    // },
    {
        id: 11,
        isActive: false,
        title: 'همکاران ما',
        icon: <ContactsOutlined />,
        link: '',
        secondaryLinks: ['/dashboard/referral-infos'],
        itemKey: 'referralWithdrawalWaitingForApprove',
        childrens: [
            {
                id: 111,
                title: 'لیست همکاران',
                link: '/dashboard/referral-infos',
            },
            {
                id: 112,
                title: 'لیست درخواست برداشت های رفرال',
                link: '/dashboard/referral-withdrawals',
                itemKey: 'referralWithdrawalWaitingForApprove',
            },
            {
                id: 113,
                title: 'لیست فعالیت همکاران',
                link: '/dashboard/referral-actions',
            },
        ],
    },
    {
        id: 12,
        isActive: false,
        title: 'نقش ها',
        icon: <AppstoreOutlined />,
        link: '/dashboard/roles',
    },
    {
        id: 13,
        isActive: false,
        title: 'تصاویر مدرک کاربران',
        icon: <CameraOutlined />,
        itemKey: 'authMediasWaitingForApprove',
        link: '/dashboard/media-surveys',
    },
    {
        id: 14,
        isActive: false,
        title: 'مدیریت حساب های بانکی',
        icon: <CreditCardOutlined />,
        link: '/dashboard/bank-accounts',
    },
    {
        id: 15,
        isActive: false,
        title: 'تراکنش های درگاه فعال',
        icon: <TransactionOutlined />,
        link: '/dashboard/gateway-transactions',
    },
    {
        id: 27,
        isActive: false,
        title: 'تاریخچه کوکوین',
        icon: <TransactionOutlined />,
        link: '/dashboard/kucoin-history',
    },
    {
        id: 16,
        isActive: false,
        title: 'جستجوی تراکنش درگاه با کد پیگیری',
        icon: <SearchOutlined />,
        link: '/dashboard/search-gateway-transaction-by-tracking-code',
    },
    {
        id: 17,
        isActive: false,
        title: 'جستجوی سفارش با کد پیگیری',
        icon: <FileSearchOutlined />,
        link: '/dashboard/search-order-by-tracking-code',
    },
    {
        id: 23,
        isActive: false,
        title: 'جستجوی سفارش با کلید واژه',
        icon: <FileWordFilled />,
        link: '/dashboard/search-order-by-keyword',
    },
    {
        id: 18,
        isActive: false,
        title: 'جستجوی کاربر با شماره موبایل',
        icon: <SearchOutlined />,
        link: '/dashboard/get-user-by-phone-number',
    },
    {
        id: 19,
        isActive: false,
        title: 'مدیریت کیف پول های ثبت شده',
        icon: <WalletOutlined />,
        link: '/dashboard/users-saved-wallets',
    },
    // {
    //     id: 20,
    //     isActive: false,
    //     title: 'مدیریت شبا های ثبت شده',
    //     icon: <CreditCardOutlined />,
    //     link: '/dashboard/users-saved-ibans',
    // },
    // {
    //     id: 21,
    //     isActive: false,
    //     title: 'ساخت/فعالسازی ووچر',
    //     icon: <CompressOutlined />,
    //     link: '/dashboard/voucher-perfectmoney',
    // },
    // {
    //     id: 22,
    //     isActive: false,
    //     title: 'گزارشات ووچر',
    //     icon: <CompressOutlined />,
    //     link: '/dashboard/voucher-logs',
    // },
    {
        id: 24,
        isActive: false,
        title: 'تنظیمات واریز ریالی',
        icon: <SettingOutlined />,
        link: '/dashboard/deposit-settings',
    },
];

export const MobileItems: MenuItem[] = [
    {
        id: 4,
        isActive: false,
        title: 'مدیریت کاربران',
        icon: <UserOutlined />,
        link: '/dashboard/users',
    },
    {
        id: 2,
        isActive: false,
        title: 'ووچر های یوتوپیا',
        icon: <BarcodeOutlined />,
        link: '/dashboard/utopia-vouchers',
    },
    {
        id: 3,
        isActive: false,
        title: 'استعلام ووچر',
        icon: <CompressOutlined />,
        link: '/dashboard/track-voucher',
    },
    {
        id: 25,
        isActive: false,
        title: 'شارژ یوتوپیا',
        icon: <CreditCardOutlined />,
        link: '/dashboard/deposit-utopia',
    },
    {
        id: 5,
        isActive: false,
        title: 'تغییر نرخ',
        icon: <ApartmentOutlined />,
        link: '/dashboard/fiats',
    },
    {
        id: 71,
        isActive: false,
        title: 'سفارشات',
        icon: <ClockCircleOutlined />,
        link: '/dashboard/orders',
    },
    {
        id: 711,
        isActive: false,
        title: 'تراکنش‌ها',
        icon: <ClockCircleOutlined />,
        link: '/dashboard/transactions',
    },
    {
        id: 7111,
        isActive: false,
        title: 'معاملات',
        icon: <ClockCircleOutlined />,
        link: '/dashboard/orders-transactions',
    },
    {
        id: 8,
        isActive: false,
        title: 'اقدامات',
        icon: <ToolOutlined />,
        link: '',
        itemKey: 'waitingForAcceptReceipt',
        childrens: [
            {
                id: 801,
                title: 'خرید',
                link: '/dashboard/orders-transactions/buys-waiting-for-admin',
                itemKey: 'buyWaitingForAcceptReceipt',
            },
            {
                id: 802,
                title: 'فروش',
                link: '/dashboard/orders-transactions/sells-waiting-for-admin',
                itemKey: 'sellWaitingForAcceptReceipt',
            },
            {
                id: 803,
                title: 'ترید',
                link: '/dashboard/orders-transactions/trades-waiting-for-admin',
                itemKey: 'tradeWaitingForAcceptReceipt',
            },
        ],
    },
    {
        id: 9,
        isActive: false,
        title: 'مدیریت محتوا',
        icon: <EditOutlined />,
        link: '',
        childrens: [
            {
                id: 1901,
                title: 'تاپیک ها',
                link: '/dashboard/content/topics',
            },
            {
                id: 1902,
                title: 'دسته بندی',
                link: '/dashboard/content/categories',
            },
            {
                id: 1903,
                title: 'محتوا',
                link: '/dashboard/content/contents',
            },
            {
                id: 1904,
                title: 'مدیریت ارز ها',
                link: '/dashboard/content/manage-markets',
            },
        ],
    },
    {
        id: 14,
        isActive: false,
        title: 'مدیریت حساب های بانکی',
        icon: <CreditCardOutlined />,
        link: '/dashboard/bank-accounts',
    },
    {
        id: 111,
        title: 'لیست همکاران',
        link: '/dashboard/referral-infos',
        isActive: false,
        icon: <TeamOutlined />,
    },
    {
        id: 112,
        title: 'لیست درخواست برداشت های رفرال',
        link: '/dashboard/referral-withdrawals',
        isActive: false,
        icon: <TransactionOutlined />,
        itemKey: 'referralWithdrawalWaitingForApprove',
    },
    {
        id: 113,
        title: 'لیست فعالیت همکاران',
        link: '/dashboard/referral-actions',
        isActive: false,
        icon: <UnorderedListOutlined />,
    },
    {
        id: 12,
        isActive: false,
        title: 'نقش ها',
        icon: <AppstoreOutlined />,
        link: '/dashboard/roles',
    },
    {
        id: 13,
        isActive: false,
        title: 'تصاویر مدرک کاربران',
        icon: <CameraOutlined />,
        link: '/dashboard/media-surveys',
    },

    {
        id: 24,
        isActive: false,
        title: 'مشاهده تراکنش های حساب',
        icon: <CreditCardOutlined />,
        link: '/dashboard/bank-account-statement',
    },
    {
        id: 15,
        isActive: false,
        title: 'تراکنش های درگاه فعال',
        icon: <TransactionOutlined />,
        link: '/dashboard/gateway-transactions',
    },
    {
        id: 26,
        isActive: false,
        title: 'گزارش کمپین ها',
        link: '/dashboard/campaign-reports',
        icon: <GiftOutlined />,
    },
    {
        id: 28,
        isActive: false,
        title: 'پاپ‌آپ ها',
        icon: <NotificationOutlined />,
        link: '/dashboard/popups',
    },
    {
        id: 27,
        isActive: false,
        title: 'تاریخچه کوکوین',
        icon: <TransactionOutlined />,
        link: '/dashboard/kucoin-history',
    },
    {
        id: 16,
        isActive: false,
        title: 'جستجوی تراکنش درگاه با کد پیگیری',
        icon: <SearchOutlined />,
        link: '/dashboard/search-gateway-transaction-by-tracking-code',
    },
    {
        id: 23,
        isActive: false,
        title: 'جستجوی سفارش با کلید واژه',
        icon: <FileWordFilled />,
        link: '/dashboard/search-order-by-keyword',
    },
    {
        id: 17,
        isActive: false,
        title: 'جستجوی سفارش با کد پیگیری',
        icon: <FileSearchOutlined />,
        link: '/dashboard/search-order-by-tracking-code',
    },
    {
        id: 18,
        isActive: false,
        title: 'جستجوی کاربر با شماره موبایل',
        icon: <SearchOutlined />,
        link: '/dashboard/get-user-by-phone-number',
    },
    {
        id: 19,
        isActive: false,
        title: 'مدیریت کیف پول های ثبت شده',
        icon: <WalletOutlined />,
        link: '/dashboard/users-saved-wallets',
    },
    // {
    //     id: 20,
    //     isActive: false,
    //     title: 'مدیریت شبا های ثبت شده',
    //     icon: <CreditCardOutlined />,
    //     link: '/dashboard/users-saved-ibans',
    // },
    // {
    //     id: 21,
    //     isActive: false,
    //     title: 'ساخت/فعالسازی ووچر',
    //     icon: <CompressOutlined />,
    //     link: '/dashboard/voucher-perfectmoney',
    // },
    // {
    //     id: 22,
    //     isActive: false,
    //     title: 'گزارشات ووچر',
    //     icon: <CompressOutlined />,
    //     link: '/dashboard/voucher-logs',
    // },
    {
        id: 24,
        isActive: false,
        title: 'تنظیمات واریز ریالی',
        icon: <SettingOutlined />,
        link: '/dashboard/deposit-settings',
    },
];
